import { render, staticRenderFns } from "./UIPagination.vue?vue&type=template&id=913b7bb0&scoped=true"
import script from "./UIPagination.vue?vue&type=script&lang=js"
export * from "./UIPagination.vue?vue&type=script&lang=js"
import style0 from "./UIPagination.vue?vue&type=style&index=0&id=913b7bb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "913b7bb0",
  null
  
)

export default component.exports